import { Chip, makeStyles } from "@material-ui/core";
import React, { useMemo } from "react";

const useStyle = makeStyles((theme) => ({
  venue: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    display: "block",
    clear: "both",
    paddingTop: theme.spacing(0.8),
    textAlign: "center",
  },
}));

const VenueField = (props) => {
  const classes = useStyle();
  const venueTypes = useMemo(
    () => props?.record?.venue_types,
    [props?.record?.venue_types]
  );

  return venueTypes.map((venueType, index) => {
    return (
      <Chip key={index} className={classes.venue} label={venueType.name} />
    );
  });
};
export default VenueField;
